import CampaignModel from "@/core/Campaign/model/CampaignModel"
import { onMounted, ref, watch } from "vue"

/**
 *
 * @param {import("@/core/Campaign/model/CampaignModel").default} campaign
 * @param {import("@vue/reactivity").UnwrapNestedRefs} campaignOptions
 * @param {import("@vue/reactivity").UnwrapNestedRefs} optionStates
 * @param {import("@vue/reactivity").Ref<number>} priceState
 * @returns
 */
export const usePriceService = function (campaign, campaignOptions, optionStates, priceState, priceBeforeDiscountState, subscriptionSelected) {

    const timerId = ref(null)

    /**
     * convert raw sub-campaigns model to array of campaign model
     * @returns {Array<import("@/core/Campaign/model/CampaignModel").default>}
     */
    const getSubCampaigns = function () {
        let result = []
        for (const item of campaign.subCampaigns) {
            result.push(new CampaignModel(item))
        }
        return result
    }

    const sumTotal = function () {
        // bases by campaign price then check options
        let total = campaign.pricePerUnit
        // check meats
        if (campaignOptions.meats != null) {
            let subCampaigns = getSubCampaigns()
            /**@type {import("@/core/Campaign/model/CampaignModel").default} */
            let subCampaign = subCampaigns.find(x => x.id == optionStates.meats.campaignId)
            // console.log(subCampaign, optionStates.meats, campaign.subCampaigns);
            if (subCampaign) {
                total = subCampaign.pricePerUnit
            }
            // console.log("sum meats", total)
        }

        // check others
        if (campaignOptions.others.length > 0) {
            for (const other of optionStates.others) {
                // check type
                if (other.type == "radio") {
                    // type: radio group
                    if (other.data != null && !(other instanceof Array)) {
                        /**@type {import("@/core/Campaign/model/CampaignModel").default} */
                        let selectedCampaign = other.data
                        total += selectedCampaign?.pricePerUnit ?? 0
                    }
                }
            }
        }

        priceBeforeDiscountState.value = total

        if (optionStates.subScription != null) {
            if (optionStates.subScription.DiscountType == "To") {
                total = optionStates.subScription.Discount; 
            } else if (optionStates.subScription.DiscountType == "Percent") {
                total = total - (total * optionStates.subScription.Discount / 100);
                total = parseFloat(total.toFixed(0))
            } else if (optionStates.subScription.DiscountType == "Price") {
                total = total - optionStates.subScription.Discount;
            }
            subscriptionSelected.value = true
        }

        // check addons
        if (campaignOptions.addOn.length > 0) {
            let filterHasQty = optionStates.addOn.filter(x => x.qty > 0)
            let sumAddOn = filterHasQty.reduce(function (a, b) {
                return a + (b.data.pricePerUnit * b.qty);
            }, 0);
            total += sumAddOn
        }

        // check multi addons
        if (campaignOptions.addOns != null && campaignOptions.addOns.length > 0) {
            for(const addon of optionStates.addOns){
                let filterHasQty = addon ? addon.filter(x => x.qty > 0) : []
                if(filterHasQty){
                    let sumAddOn = filterHasQty.reduce(function (a, b) {
                        return a + (b.data.pricePerUnit * b.qty);
                    }, 0);
                    total += sumAddOn
                }
            }
        }


        // check appetizers
        if (campaignOptions.appetizers != null && campaignOptions.appetizers.length > 0) {
            let array = optionStates.appetizers
            for(let i = 0; i < campaignOptions.appetizers.length; i++){
                if (campaignOptions.appetizers[i]?.maximum_item !== undefined) {
                    if(array[i] !== undefined && array[i]?.list?.length > 0){
                        for(const item of array[i].list){
                            if(item?.pricePerUnit){
                                total += item?.pricePerUnit ?? 0
                            }
                        }
                    }
                }else {
                    if(array[i]){
                        let filterHasQty = array[i].filter(x => x?.qty > 0)
                        let sumAddOn = filterHasQty.reduce(function (a, b) {
                            if(b?.data?.pricePerUnit && b?.qty){
                                return a + (b?.data?.pricePerUnit * b?.qty);
                            }
                            return 0
                        }, 0);
                        total += sumAddOn
                    }
                }
            }
        }

        // calculate with main qty
        if(optionStates?.quantity?.qty){
            priceState.value = total * optionStates.quantity.qty
            
        }

        

        // calculate discount
        // if (optionStates?.subScription?.DiscountAmount) {
        //     priceState.value = priceState.value - optionStates?.subScription?.DiscountAmount
        // }

        console.log("sumTotal", priceState.value)
        console.log("sumTotal priceBeforeDiscountState", priceBeforeDiscountState.value)

    }

    watch(optionStates, () => {
        console.log("watch optionStates", optionStates)
        // performance
        clearTimeout(timerId.value)
        timerId.value = setTimeout(() => {
            // console.log(val.addOn)
            sumTotal()
        }, 250);
    })

    onMounted(sumTotal)
}

export default usePriceService
